import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Spin } from 'antd';
import { useQuery } from '@tanstack/react-query';

import { useGlobals } from '../globals-context';
import EVENTS from '../constants/event-bus-events';
import MicroApp from '../components/MicroApp';
import useMicroServicesTools from '../hooks/use-micro-services-tools';
import useMerchantSettings from '../hooks/use-merchant-settings';
import createQueryConfig from '../queries';

const containerStyle = {
  display: 'flex',
  height: '100%',
  flex: 1,
};

const loadingContainerStyle = {
  ...containerStyle,
  justifyContent: 'center',
  alignItems: 'center',
};

const contractStyle = {
  flex: 1,
};

function Loading() {
  return (
    <div style={loadingContainerStyle}>
      <Spin />
    </div>
  );
}

export function ContractApp() {
  const { eventBus, queryClient, apiClient } = useGlobals();
  const microServicesTools = useMicroServicesTools('contract');
  const { isLoading: isLoadingSettings, merchantSettings } =
    useMerchantSettings();
  const queryConfig = createQueryConfig(queryClient, apiClient);
  const { status: subscriptionQueryStatus } = useQuery(
    queryConfig.subscription(merchantSettings)
  );
  const hasChargebeeSubscription = subscriptionQueryStatus === 'success';

  useEffect(() => {
    eventBus.emit(EVENTS.DISABLE_SPINNER);
    eventBus.emit(EVENTS.CLOSE_MENU);

    return () => {
      eventBus.emit(EVENTS.ENABLE_SPINNER);
    };
  }, []);

  if (isLoadingSettings || subscriptionQueryStatus === 'pending') {
    return <Loading />;
  }

  if (hasChargebeeSubscription) {
    return <Navigate to="/subscription" />;
  }

  const location = useLocation();
  const fullPath = `${location.pathname}${location.search}`;

  return (
    <div style={containerStyle}>
      <MicroApp
        name="contract"
        style={contractStyle}
        loading={<Loading />}
        settings={merchantSettings}
        mountPath="/contract"
        pathAndQuery={fullPath}
        useHashHistory={false}
        {...microServicesTools}
      />
    </div>
  );
}
